import { useTarget } from "lib/@hooks/use-target"
import { emptyObject } from "lib/empty-object"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { Bound } from "lib/@components/binding/Bound"

export function TargetGuard({ children, notEmpty, fallback = <LoadingScreen /> }) {
    const target = useTarget()
    if (!target || target === emptyObject || (notEmpty && Object.isEmpty(target))) return fallback
    return (
        <Bound guardedTarget={target} guardedTargetId={target?._id}>
            {children}
        </Bound>
    )
}
